"use strict";

require("core-js/modules/es6.object.define-property.js");

require("core-js/modules/es6.string.includes.js");

require("core-js/modules/es7.array.includes.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.array.index-of.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.date.to-string.js");

require("core-js/modules/es6.regexp.to-string.js");

require("core-js/modules/es6.number.constructor.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.array.map.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactLoaderAdvanced = _interopRequireDefault(require("react-loader-advanced"));

var _reactLoadingSpin = _interopRequireDefault(require("react-loading-spin"));

var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));

var _SearchResultsMessage = _interopRequireDefault(require("../../components/SearchResultsMessage"));

var _SearchListItem = _interopRequireDefault(require("../../components/SearchListItem"));

var _SearchInput = _interopRequireDefault(require("../../components/SearchInput"));

var _SearchPaginationResults = _interopRequireDefault(require("../../components/SearchPaginationResults"));

var _SearchPageSizer = _interopRequireDefault(require("../../components/SearchPageSizer"));

var _search_defaults = require("../../services/search/search_defaults");

var SearchContent = function SearchContent(_ref) {
  var _useContext = (0, _react.useContext)(_search_defaults.SearchDispatch),
      searchState = _useContext.searchState,
      dispatch = _useContext.dispatch,
      defaultFacets = _useContext.defaultFacets;

  var dateModified = new Date();
  var updatedDay = dateModified.getDate();
  var updatedMonth = dateModified.getMonth();
  var updatedFullYear = dateModified.getFullYear();
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var dateString = months[updatedMonth] + ' 1,' + updatedFullYear;

  if (searchState && searchState.items && searchState.items[0] && searchState.items[0]['description'] && searchState.items[0]['description'].includes('Updated Monthly:') === false) {
    for (var i = 0; i < searchState.items.length; i++) {
      searchState.items[i]['description'] = "".concat(searchState.items[i]['description'], " - (Updated Monthly: ").concat(dateString, ")");
    }
  } // console.log(_useContext,_ref,"_useContext")


  var cTab = _ref.tab;
  var items = searchState.items,
      fulltext = searchState.fulltext,
      totalItems = searchState.totalItems,
      selectedFacets = searchState.selectedFacets,
      loading = searchState.loading;

  if (cTab === '1') {
    var oldLen = items.length;
    items = items.filter(function (f) {
      return f.publisher === "Washington State Housing Finance Commission";
    });

    if (fulltext) {
      items = items.filter(function (f) {
        return f.publisher && f.publisher.toLowerCase().indexOf(fulltext.toLowerCase()) > -1 || f.description && f.description.toLowerCase().indexOf(fulltext.toLowerCase()) > -1 || f.title && f.title.toLowerCase().indexOf(fulltext.toLowerCase()) > -1;
      }); // items = items.filter(f=>((f.publisher && f.publisher.toLowerCase().indexOf(fulltext.toLowerCase())>-1) || (f.description && f.description.toLowerCase().indexOf(fulltext.toLowerCase())>-1) || (f.title && f.title.toLowerCase().indexOf(fulltext.toLowerCase())>-1) || (f.theme && JSON.stringify(f.theme).toLowerCase().indexOf(fulltext.toLowerCase())>-1)))
    }

    var newLen = items.length;
    var len = oldLen - newLen;
    totalItems = (Number(totalItems) - len).toString();
  } else if (cTab === '2') {
    var oldLen = items.length;
    items = items.filter(function (f) {
      return f.publisher !== "Washington State Housing Finance Commission";
    });
    var newLen = items.length;
    var len = oldLen - newLen;
    totalItems = (Number(totalItems) - len).toString();
  }

  var facetTypes = Object.keys(defaultFacets);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dc-results-list col-md-8 col-sm-12"
  }, items && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
    placeholder: "Type your search term here",
    showSubmit: false,
    srOnly: true,
    value: fulltext,
    onChangeFunction: dispatch,
    onResetFunction: function onResetFunction() {
      return dispatch({
        type: 'RESET_FULLTEXT'
      });
    },
    resetContent: "Clear text"
  }), /*#__PURE__*/_react["default"].createElement(_SearchResultsMessage["default"], {
    searchTerm: fulltext,
    total: parseInt(totalItems, 10),
    selectedFacets: selectedFacets,
    facetTypes: facetTypes,
    defaultFacets: defaultFacets,
    facetLimit: 100,
    facetDelimiter: ", ",
    facetSeparator: " & "
  }), /*#__PURE__*/_react["default"].createElement(_reactLoaderAdvanced["default"], {
    hideContentOnLoad: true,
    backgroundStyle: {
      backgroundColor: '#f9fafb'
    },
    foregroundStyle: {
      backgroundColor: '#f9fafb'
    },
    show: loading,
    message: /*#__PURE__*/_react["default"].createElement(_reactLoadingSpin["default"], {
      width: "3px",
      primaryColor: "#007BBC"
    })
  }, /*#__PURE__*/_react["default"].createElement("ol", null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_SearchListItem["default"], {
      key: item.identifier,
      item: item
    });
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dc-pagination-container"
  }, /*#__PURE__*/_react["default"].createElement(_SearchPaginationResults["default"], {
    total: Number(totalItems),
    pageSize: Number(searchState['page-size']),
    currentPage: Number(searchState.page)
  }), /*#__PURE__*/_react["default"].createElement(_SearchPageSizer["default"], {
    currentValue: Number(searchState['page-size']),
    resizeFunc: function resizeFunc(e) {
      return dispatch({
        type: 'UPDATE_PAGE_SIZE',
        data: {
          'page-size': e.target.value
        }
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactJsPagination["default"], {
    hideDisabled: true,
    activePage: searchState.page,
    itemsCountPerPage: Number(searchState['page-size']),
    totalItemsCount: Number(totalItems),
    pageRangeDisplayed: 5,
    onChange: function onChange(e) {
      return dispatch({
        type: 'UPDATE_CURRENT_PAGE',
        data: {
          page: e
        }
      });
    }
  }))));
};

var _default = SearchContent;
exports["default"] = _default;